module.exports = __webpack_public_path__ + "img/beer_id-45.e0510de3.png";